<template>
  <div class="bg-gray-100 py-6" style="height:calc(100vh - 70px)">
    <div
      class="Polaris-Box max-w-xl mx-auto"
      style="--pc-box-background:var(--p-surface);--pc-box-border-radius:var(--p-border-radius-2);--pc-box-padding-block-end-xs:var(--p-space-4);--pc-box-padding-block-end-sm:var(--p-space-5);--pc-box-padding-block-start-xs:var(--p-space-4);--pc-box-padding-block-start-sm:var(--p-space-5);--pc-box-padding-inline-start-xs:var(--p-space-4);--pc-box-padding-inline-start-sm:var(--p-space-5);--pc-box-padding-inline-end-xs:var(--p-space-4);--pc-box-padding-inline-end-sm:var(--p-space-5);--pc-box-shadow:var(--p-shadow-card)"
    >
      <div class="Polaris-SettingAction">
        <div class="Polaris-SettingAction__Setting">
          <div
            class="Polaris-Inline"
            style="--pc-inline-align:start;--pc-inline-block-align:center;--pc-inline-wrap:wrap;--pc-inline-gap-xs:var(--p-space-4)"
          >
            <div
              class="Polaris-AlphaStack"
              style="--pc-stack-align:start;--pc-stack-order:column;--pc-stack-gap-xs:var(--p-space-2)"
            >
              <h2
                class="Polaris-Text--root Polaris-Text--headingLg Polaris-Text--semibold"
              >
                Abandoned Cart Templates
              </h2>
            </div>
          </div>
        </div>
        <div class="Polaris-SettingAction__Action">
          <button
            class="Polaris-Button Polaris-Button--primary"
            type="button"
            @click="createNew('Abandoned')"
          >
            <span class="Polaris-Button__Content">
              <span class="Polaris-Button__Text">Create new</span>
            </span>
          </button>
        </div>
      </div>
      <div
        class="Polaris-Box"
        style="--pc-box-padding-block-start-xs:var(--p-space-5)"
      >
        <ul>
          <TemplateItem
            :template="template"
            @edit="onEdit($event, 'Abandoned')"
            @delete="onDelete($event, 'Abandoned')"
            v-for="template in templates"
            :key="template.id"
          />
        </ul>
      </div>
    </div>

    <div
      class="Polaris-Box max-w-xl mx-auto mt-4"
      style="--pc-box-background:var(--p-surface);--pc-box-border-radius:var(--p-border-radius-2);--pc-box-padding-block-end-xs:var(--p-space-4);--pc-box-padding-block-end-sm:var(--p-space-5);--pc-box-padding-block-start-xs:var(--p-space-4);--pc-box-padding-block-start-sm:var(--p-space-5);--pc-box-padding-inline-start-xs:var(--p-space-4);--pc-box-padding-inline-start-sm:var(--p-space-5);--pc-box-padding-inline-end-xs:var(--p-space-4);--pc-box-padding-inline-end-sm:var(--p-space-5);--pc-box-shadow:var(--p-shadow-card)"
    >
      <div class="Polaris-SettingAction">
        <div class="Polaris-SettingAction__Setting">
          <div
            class="Polaris-Inline"
            style="--pc-inline-align:start;--pc-inline-block-align:center;--pc-inline-wrap:wrap;--pc-inline-gap-xs:var(--p-space-4)"
          >
            <div
              class="Polaris-AlphaStack"
              style="--pc-stack-align:start;--pc-stack-order:column;--pc-stack-gap-xs:var(--p-space-2)"
            >
              <h2
                class="Polaris-Text--root Polaris-Text--headingLg Polaris-Text--semibold"
              >
                Order Templates
              </h2>
            </div>
          </div>
        </div>
        <div class="Polaris-SettingAction__Action">
          <button
            class="Polaris-Button Polaris-Button--primary"
            type="button"
            @click="createNew('Order')"
          >
            <span class="Polaris-Button__Content">
              <span class="Polaris-Button__Text">Create new</span>
            </span>
          </button>
        </div>
      </div>
      <div
        class="Polaris-Box"
        style="--pc-box-padding-block-start-xs:var(--p-space-5)"
      >
        <ul>
          <TemplateItem
            :template="template"
            @edit="onEdit($event, 'Order')"
            @delete="onDelete($event, 'Order')"
            v-for="template in orderTemplates"
            :key="template.id"
          />
        </ul>
      </div>
    </div>

    <TemplateModal
      v-if="showModal"
      :template="currentTemplate"
      @edit="onUpdate"
      @close="closeModal"
      @create="onCreate"
      :templateType="templateType"
    />
  </div>
</template>

<script>
import TemplateItem from "@/components/Common/TemplateItem.vue";
import TemplateModal from "@/components/Common/TemplateModal.vue";

export default {
  name: "Templates",
  components: {
    TemplateItem,
    TemplateModal
  },
  data() {
    return {
      showModal: false,
      currentTemplate: null,
      templateType: "Abandoned"
    };
  },
  computed: {
    templates() {
      return this.$store.getters.getTemplates;
    },
    orderTemplates() {
      return this.$store.getters.getOrderTemplates;
    }
  },
  created() {
    this.loadTemplates();
  },
  methods: {
    loadTemplates() {
      this.$store.dispatch("getTemplates");
      this.$store.dispatch("getOrderTemplates");
    },
    closeModal() {
      this.showModal = false;
    },
    openModal() {
      this.showModal = true;
    },
    createNew(templateType) {
      this.templateType = templateType;
      this.currentTemplate = null;
      this.openModal();
    },
    async onCreate({ body, name }) {
      if (this.templateType === "Abandoned") {
        await this.$store.dispatch("createTemplate", {
          requestParams: {
            body,
            name
          }
        });
      }

      if (this.templateType === "Order") {
        await this.$store.dispatch("createOrderTemplate", {
          requestParams: {
            body,
            name
          }
        });
      }

      this.loadTemplates();
    },
    async onUpdate({ body, name }) {
      if (this.templateType === "Abandoned") {
        await this.$store.dispatch("updateTemplate", {
          templateId: this.currentTemplate.id,
          requestParams: {
            body,
            name
          }
        });
      }

      if (this.templateType === "Order") {
        await this.$store.dispatch("updateOrderTemplate", {
          templateId: this.currentTemplate.id,
          requestParams: {
            body,
            name
          }
        });
      }

      this.loadTemplates();
    },
    onEdit(template, templateType) {
      this.currentTemplate = template;
      this.templateType = templateType;
      this.openModal();
    },
    async onDelete(template, templateType) {
      this.templateType = templateType;
      if (this.templateType === "Abandoned") {
        await this.$store.dispatch("deleteTemplate", {
          templateId: template.id
        });
      }
      if (this.templateType === "Order") {
        await this.$store.dispatch("deleteOrderTemplate", {
          templateId: template.id
        });
      }
      this.loadTemplates();
    }
  }
};
</script>

<style lang="scss" scoped></style>
